// create context provider and use context

import { useAuth } from 'context/Auth';
import React, { createContext } from 'react';
import { BeCustomer } from 'types/customer';
import { BeVoucher, BeVoucherCondition } from 'types/voucher';
import { useGetVoucherInfo } from './hooks/useGetVoucherInfo';
import { useGetVoucherCondition } from './hooks/useGetVoucherCondition';

interface VoucherDetailContext {
  user: BeCustomer;
  isVoucherLoading: boolean;
  isStatusLoading: boolean;
  voucherInfo?: BeVoucher;
  refetchVoucherInfo: () => void;
  condition?: BeVoucherCondition;
}

export const VoucherDetailContext = createContext<VoucherDetailContext | null>(null);

export const VoucherDetailProvider: React.FC<{ code: string; isLoading?: boolean }> = ({ children, code, isLoading }) => {
  const { user } = useAuth() as { user: BeCustomer };

  const { isLoading: isVoucherLoading, isStatusLoading, voucherInfo, refetchVoucherInfo } = useGetVoucherInfo(code);
  const { condition } = useGetVoucherCondition({ code });

  return (
    <VoucherDetailContext.Provider
      value={{ user, voucherInfo, isVoucherLoading: isVoucherLoading || !!isLoading, isStatusLoading, refetchVoucherInfo, condition }}
    >
      {children}
    </VoucherDetailContext.Provider>
  );
};

export const useVoucherDetailContext = () => {
  const context = React.useContext(VoucherDetailContext);
  if (!context) {
    throw new Error('useVoucherDetailContext must be used within a VoucherDetailProvider');
  }
  return context;
};

